import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Checkbox, Typography, Layout, Row, Col, Image, Flex, message } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
// import '../login.css';
import wlogo from '../assets/onespa-logo.png';
import blogo from '../assets/onespa-logo.png';
import { GiLaptop } from 'react-icons/gi';
import { BsBalloonHeart, BsChatLeftHeart, BsRobot, BsWhatsapp } from 'react-icons/bs';

const { Link, Title, Text, Paragraph } = Typography;

const getDeviceInfo = () => {
    const userAgent = navigator.userAgent;
    let deviceType, deviceOS;

    if (/android/i.test(userAgent)) {
        deviceType = 'Android';
        // eslint-disable-next-line no-useless-escape
        const match = userAgent.match(/Android\s([0-9\.]+)/);
        deviceOS = match ? `Android ${match[1]}` : 'Android';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        deviceType = 'iOS';
        // eslint-disable-next-line no-useless-escape
        const match = userAgent.match(/OS\s([0-9\._]+)/);
        deviceOS = match ? `iOS ${match[1].replace(/_/g, '.')}` : 'iOS';
    } else if (/Windows NT/.test(userAgent)) {
        deviceType = 'Windows';
        // eslint-disable-next-line no-useless-escape
        const match = userAgent.match(/Windows NT\s([0-9\.]+)/);
        deviceOS = match ? `Windows ${match[1].replace(/_/g, '.')}` : 'Windows';
    } else {
        deviceType = 'Web';
        deviceOS = 'N/A';
    }
    return { deviceType, deviceOS };
};

const LoginForm = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [shake, setShake] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        setShake(false);
        const url = `${window.API_BASE_URL}/auth/adminlogin`;
        const deviceId = uuidv4();
        const { deviceType, deviceOS } = getDeviceInfo();

        const requestBody = {
            identifier: values.identifier,
            admin_password: values.password,
            device_id: deviceId,
            device_type: deviceType,
            device_os: deviceOS
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            const data = await response.json();
            console.log('Response:', data);

            if (response.ok) {
                if (data.success === true) {
                    message.success('Login Successfull');
                    localStorage.setItem('adminLoginToken', data.token);
                    localStorage.setItem('adminDeviceId', deviceId);
                    setTimeout(() => {
                        navigate('/');
                    }, 500);
                } else {
                    message.success('Login Failed');
                    console.error('Login failed:', data.message);
                }
            } else {
                console.error('Login failed:', data.message);
                message.success('Login Failed');
                setShake(true);
                setTimeout(() => setShake(false), 500);
            }
        } catch (error) {
            console.error('Error:', error);
            setShake(true);
            setTimeout(() => setShake(false), 500);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitFailed = () => {
        setShake(true);
        setTimeout(() => setShake(false), 500);
    };

    return (
        <Layout style={{ backgroundColor: '#FFFFFF' }}>
            <Row justify={'center'} align={'center'}>
                <Col sm={24} md={8} lg={8}>
                    <div className='register-right-side'>
                        <div className={`reg-right-main-div ${shake ? 'shake' : ''}`} style={{ minWidth: 415 }}>
                            <Flex justify='center' align='center' style={{ marginTop: 24 }} className='on-phone'>
                                <div className='main-reg-logo'>
                                    <Image src={blogo} preview={false} className='reg-logo' />
                                </div>
                            </Flex>
                            <Form
                                name="login_form"
                                onFinish={handleSubmit}
                                onFinishFailed={handleSubmitFailed}
                                layout="vertical"
                            >
                                <Form.Item
                                    name="identifier"
                                    label="Email or Phone"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your email or phone number!',
                                        },
                                    ]}
                                >
                                    <Input autoComplete='username' placeholder="Enter your email or phone number" />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    label="Password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        autoComplete="current-password"
                                        placeholder="Enter your password"
                                        iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                                        onClick={togglePasswordVisibility}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Checkbox>Remember me</Checkbox>
                                </Form.Item>
                                <Form.Item style={{ textAlign: 'center' }}>
                                    <Button type="primary" htmlType="submit" block loading={loading} style={{ height: 44, fontWeight: 500, marginTop: 24 }}>
                                        {!loading && 'Login to your OneSpaAI.com account'}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </Layout>
    );
};

export default LoginForm;